import { head, split } from "lodash";

const Polarities = ["positive", "negative"] as const;

type Polarity = typeof Polarities[number];

const PolarityColors: Record<Polarity, string> = {
  negative: "#E64C65",
  positive: "#1FAA7A",
};

function getAffectPolarity(id: string): Polarity {
  const polarity = head(split(id, "."));
  return polarity === "negative" ? polarity : "positive";
}

export function getAffectColor(affect: string): string {
  return PolarityColors[getAffectPolarity(affect)];
}

export function getAllAffectPolarities() {
  return Polarities;
}
